import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import HeaderComponent from './HeaderComponent';
import ServicesComponent from './ServiceComponents/ServicesComponent';
import { Router, Route, Switch } from 'react-router-dom';
import { history } from '../Helpers/history';
import PrivateRoute from "./PrivateRoute"
import LoginPage from './LoginPage';
import { theme } from '../AppData/theme';

class IndexPage extends Component {
    transportOrderComponentContent = () => {
        return <ServicesComponent></ServicesComponent>
    }

    render() {
        const { classes, ...otherProps } = this.props;
        let headerBar = <React.Fragment></React.Fragment>;
        if (this.props.authReducer.loggedIn) {
            headerBar = <div clasName={classes.header}>
                <HeaderComponent {...otherProps} history={history}></HeaderComponent>
            </div>;
        }

        console.log(process.env.PUBLIC_URL);

        return (
            <MuiThemeProvider theme={theme}>
                <Router basename={`${process.env.PUBLIC_URL}`}  history={history}>
                    <div className={classes.dashboard}>
                        {headerBar}
                        <div>
                            <Switch>
                                <Route path={process.env.PUBLIC_URL + "/login"} render={() => <LoginPage history={history} {...otherProps}></LoginPage>} />
                                <PrivateRoute loggedIn={this.props.authReducer.loggedIn}  exact path={process.env.PUBLIC_URL + "/"} children={this.transportOrderComponentContent(otherProps)} />
                            </Switch>
                        </div>
                    </div>
                </Router>
            </MuiThemeProvider>
        )
    }
}

const styles = {
    dashboard: {
        display: "inline-block",
        width: "100%",
        height: "calc(100vh - 20px)",
        backgroundColor: "#F5F5F5"
    },
    container: {
        height: "100%"
    }
};

export default withStyles(styles)(IndexPage);
